// extracted by mini-css-extract-plugin
module.exports = {"container":"share_icons-module--container--1rwKu","iconContainer":"share_icons-module--iconContainer--xmi7K","icon":"share_icons-module--icon--mVOyC"};